import { render } from "./RicercaModello.vue?vue&type=template&id=a169c9ea"
import script from "./RicercaModello.vue?vue&type=script&lang=js"
export * from "./RicercaModello.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__